
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqlix8aI8fTPdvyxVGFZb8ueAhcUDGAxHD_xQ9EH0PrzMMeta } from "/codebuild/output/src1494224484/src/src/pages/faq.vue?macro=true";
import { default as menunBmA_45_45kFMFEOlbhgIFpwnLHur7q8K8zkixZ6pcok7YYMeta } from "/codebuild/output/src1494224484/src/src/pages/menu.vue?macro=true";
import { default as indexXN_ee9EDi6XoSHzIMV1Om3ALmd3nTvhH3Yv4hRTY_QoMeta } from "/codebuild/output/src1494224484/src/src/pages/index.vue?macro=true";
import { default as contacty_45dtxDy0GJ_45uglDnqSE9Jh_sirVfYv7_p2xbmBe7s7wMeta } from "/codebuild/output/src1494224484/src/src/pages/contact.vue?macro=true";
import { default as tutorialgf2IzUfAMmbszkxmEm4rpFYJxa7dUY_BEszvOCcWUO8Meta } from "/codebuild/output/src1494224484/src/src/pages/tutorial.vue?macro=true";
import { default as agreementlbZGfJ9MVz_45uuj390hDpkEit_gmZ_45PbY3sjekf0PkNcMeta } from "/codebuild/output/src1494224484/src/src/pages/agreement.vue?macro=true";
import { default as about_45passkJ_45H358tqYOftrkatLRuu62Y82YLrVf5PgF6QxX1jQUMeta } from "/codebuild/output/src1494224484/src/src/pages/about-pass.vue?macro=true";
import { default as indexDTIPMlLvFrqVjm1Xx0dodni6ojlfJFqzZT41IT9MQVcMeta } from "/codebuild/output/src1494224484/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93o_45dioI_0EdPfazlXADtTkcoedPzyDYRXJg0BiREL04wMeta } from "/codebuild/output/src1494224484/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceU8H_bm1lNC_WzuN3r7n5JnAT93Ebxn5mVA9iGuetzJkMeta } from "/codebuild/output/src1494224484/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93OT6_45FqxZLNfOXtKOdDyfFCWbw2JvwofzefWWDbh5K3gMeta } from "/codebuild/output/src1494224484/src/src/pages/notice/[id].vue?macro=true";
import { default as indexxE2g6v6nwQAdqaF_MDq1X6lkhRImoNTKM5t440vFJHEMeta } from "/codebuild/output/src1494224484/src/src/pages/coupon/index.vue?macro=true";
import { default as indexzGSouKbb_45x7dRP_45PUiZWiipreHLZEwjB59IjXdBZW6MMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/index.vue?macro=true";
import { default as indexR81eCPaIenONfg6DM9f17SEZ0VYd5tg1e8e6nsrkckMMeta } from "/codebuild/output/src1494224484/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93WU_5lphC5LX5Uw1NlEBOKfugEUv9xg_UHjKtCO8XgkEMeta } from "/codebuild/output/src1494224484/src/src/pages/parking/[id].vue?macro=true";
import { default as indexELXN_45whWh6w9K7PI1hsBguUP_YSKvarQq1mK8ZvE35kMeta } from "/codebuild/output/src1494224484/src/src/pages/history/index.vue?macro=true";
import { default as indexrLIOaUflG539NY1tPeodEWNtmn45NWm3MAgH_45TXtzgUMeta } from "/codebuild/output/src1494224484/src/src/pages/monthly/index.vue?macro=true";
import { default as indexcgrRNkQr2EoLd9r0qjlMY8vavbYwF7O_DhMLCpf_2cMMeta } from "/codebuild/output/src1494224484/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexWIpDilZh5sFD9wa_4qRJfjHSBwTA_45YsNUXQXpa9pfpkMeta } from "/codebuild/output/src1494224484/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviXIhJzM4cbqXtqNa3jHFB9Sr1W6B7Ym6_CPqt22CpVwYMeta } from "/codebuild/output/src1494224484/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editT2FmqITiYCH0GvdzoieE3pHshvwRB4rDTZhOJtHF61oMeta } from "/codebuild/output/src1494224484/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement5AoweVHoi9W7jKCegVK09fBr_45it_4RHbUdR8inPs_45KQMeta } from "/codebuild/output/src1494224484/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexpFvnW3P1IhjMYbglfvKS2DPJM_XnGb2JT2IO1ne_45PpMMeta } from "/codebuild/output/src1494224484/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dC7EmSR6_459lBOjKDENmVqVFmKFQQAvyetfsAgMyi0LBAMeta } from "/codebuild/output/src1494224484/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm0Xu5ve_45vcU_w07OsatWUrpede_45ESl0gyJcMwChZAvBMMeta } from "/codebuild/output/src1494224484/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexiWvao2SbfpswX7NuiTElh_w_RQy1eqh7ifP4Oa7cr0sMeta } from "/codebuild/output/src1494224484/src/src/pages/card/create/index.vue?macro=true";
import { default as index9MvnbAn5yq3L_EaaqRdFJMg46ytQ5xFGGKiBMuxKB_IMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmeu5o926kpDJFpaL3Uq4KOupjhwMPOMMswETWZIhUJScMeta } from "/codebuild/output/src1494224484/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmNy9_UztvDATMtzJw75K9SBuVBrGi_DcKT2XzHKpv_r4Meta } from "/codebuild/output/src1494224484/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completePtx8Vf7Gk4ec0CS5mQUK7DNncsYImuHGLc6nqnmTsaMMeta } from "/codebuild/output/src1494224484/src/src/pages/membership/complete.vue?macro=true";
import { default as registerBDeWZQk7zldNRdCWsUb891giSybq9jPlsN0tuY9IyIAMeta } from "/codebuild/output/src1494224484/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93upKr1vsUVbPcN3Ih3dt_4WLux4EtuaUHNjDxp_45_45pBUMMeta } from "/codebuild/output/src1494224484/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm5jqt6m29B_45_45XgR3ghHfgj3X4MzE0yfLsCi6HE_b7OzAMeta } from "/codebuild/output/src1494224484/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93tcmS4WGPeADN3uAuAxhnLrxh_Z61xkud2TaceK9MkNAMeta } from "/codebuild/output/src1494224484/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexylzXHLnf8AiYN8IcjexQJVo_nNlMqEuv1vRQSDLqA3sMeta } from "/codebuild/output/src1494224484/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codefGVebUPLicE3NBFNntx8cIMbWgc_E5xladuIbqcTg4UMeta } from "/codebuild/output/src1494224484/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeduAgn6eIkUJPw2TaeDr2QBqNczHuMFnvdtgnC7Vdh_45wMeta } from "/codebuild/output/src1494224484/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeV4pMUsYBlosw4oM5kjzf518hQnARixL_45ZGVTb6eepMUMeta } from "/codebuild/output/src1494224484/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerc8eO76sGbotARjnLAPEzr_459AFyCoOrkg7LlYBP72ycsMeta } from "/codebuild/output/src1494224484/src/src/pages/contact-form/register.vue?macro=true";
import { default as completesGPbbx35odZeQYeaJC07mwvtnwErYLOzXrNQA1HEb4gMeta } from "/codebuild/output/src1494224484/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index9_dhgsMPpT_45LMbinv1w5qUxhVA6SfIy6ntTcY1SSSFoMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmC4A2Tcy_45_45p5_45DeVaDrBFF_iofrZwXVGHRE94QVzZUcoMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeBfShZYPGYqpLqpmQDlcCWeRaPHBXT5drXClJxdUnKn8Meta } from "/codebuild/output/src1494224484/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexDS1tbXKBVsSkkbDvh_5ncKG4cL3sSzdocRH4tD6Hwr0Meta } from "/codebuild/output/src1494224484/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93eOzb_45_459n6OPhutSbeqZ98QqD7Qr_GXCp8YzEY6KneokMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeIvugPrzKXfyM4FrSIzrrBIy6Yi16Rb8MXKsRHahwvuYMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasbXNmVR4x5e6fU5VbvHvHq1iDeP1DrpG4fI7e811BJPkMeta } from "/codebuild/output/src1494224484/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampledJYbS3h3b2DFADqYZmEVYujwA7Mc3y9NceytxpCzjSIMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailWhUllfF4_45qHId4FDDbuO1_45OCZpx1kiMkx8YBOtzmz4sMeta } from "/codebuild/output/src1494224484/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm8dQX1VLZdiCarP5bJl6wDLUeKzlkrxPVLUWZTZX4TVkMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentt_45kEGattoZ5GiD6ERfrFh8XUIr1qwdD3Qw2MtMuvX1QMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm6yvVeSWp0tzf38vsRxiHZiRCnQjfHPITREdkbnrT3Q4Meta } from "/codebuild/output/src1494224484/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatewQxV_452X5Tq2B2LfTl6bT73YY_7JIJ8kDD6SoQtkKHUMMeta } from "/codebuild/output/src1494224484/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete412cyNG2kfQah_454fczNXg1cL0rhVeuEwoGE8OaBxN_45sMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeM1uXwGeAtZNB8IYS803ZN51OmCNFO2sPVLhfhttarh0Meta } from "/codebuild/output/src1494224484/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordDvCH0_45zR78UbaCgxEdBkJdjJfrR2BtZpqLBmW1fHihsMeta } from "/codebuild/output/src1494224484/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliassuKG8w1vWHLz0QFqJaJ04AiUY3_45_pq6T6dXpGUFNmO8Meta } from "/codebuild/output/src1494224484/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerURHUuMtmyvL3QXagc9KmHzuJ8GW_nANh1pOs0SSd36kMeta } from "/codebuild/output/src1494224484/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code4Tb4G3debtEviWXeuUugrUxNrnvvuoVWRGs2pP_uQ5sMeta } from "/codebuild/output/src1494224484/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index1B9c7Hlrqi0Id9Fm5M6P_45wv8Ejr0Gn4TRON5CeTPedcMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexeAzklymG9snl6FrUtwvql_45MuzSZNVt5O_45GlYfHcCwyMMeta } from "/codebuild/output/src1494224484/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index18yZxwJZd525o2OvKfbLmGPOVzkBhSxVhU8MmmT2K1AMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexEAwNYQW1DEYn5OEQSHieCmq8trnF5HAPrS_YRyGo8ZoMeta } from "/codebuild/output/src1494224484/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update_45ku4DAy0g3Fy2LituY5jxLRpUzV3ho0_45qj5fFVv9tRUMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completebcZMCIkvCpANV_oYN2MlqepxA9L07d6p8I_ArQ64N50Meta } from "/codebuild/output/src1494224484/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmd_RRYfmq_45HSEc36p2VTjNFMR6xF6O2XKEOR1vKtyLpkMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexffVhmJZoymDPqVa3o3eypz0Ab8Jvwzb_QZrz_IbWrPUMeta } from "/codebuild/output/src1494224484/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completek2W613ximQiGrWb_CODcdT9u7uk1VkMRyrNUD6HM4LsMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update2a_45yZOfb625C8OnnNV2jOST3Ub3UlS6YweuZ8ywl6QsMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indextxzbmbmSQNPuKmmg8K_45hFjXyummiGm_45_ghqfsSpNKUoMeta } from "/codebuild/output/src1494224484/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexJIEejpLjXkpl03JLtpmhaFAjrVDkccOcWleSZIJQnFEMeta } from "/codebuild/output/src1494224484/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completepgUnVcPeUJrEgLUD4GG17tgm08HY1DmipNNRgtVNTIAMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexzRwOfaHP4Wqdh8HeZp7njOhBhRkY7yTA4fln2MMZZzAMeta } from "/codebuild/output/src1494224484/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codey0DqZfuD4DoN1GEGn43YOX7nUvHerp58OgDE2o4OnPcMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index3f5SwU_45hCLjKuTsa7GNcRxny3e0KaUOiyHXht20bljcMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexuwxVOUa9pKs5J0SKySdl9kBPOJJauBDbUe9vzoPpkoUMeta } from "/codebuild/output/src1494224484/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexzrKgL5H6cNzm1hGY4V4Mbkwn5V671crPNCN5dJnGZ8AMeta } from "/codebuild/output/src1494224484/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update81IM241KbZlSfEwPBHmRat4IQP0aEzRsRdLgCTBbMt4Meta } from "/codebuild/output/src1494224484/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmjaVzllw0L18w2RD1o5BwiZYTvEZkrODJWZK_45C7L9njMMeta } from "/codebuild/output/src1494224484/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menunBmA_45_45kFMFEOlbhgIFpwnLHur7q8K8zkixZ6pcok7YYMeta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexXN_ee9EDi6XoSHzIMV1Om3ALmd3nTvhH3Yv4hRTY_QoMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src1494224484/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexxE2g6v6nwQAdqaF_MDq1X6lkhRImoNTKM5t440vFJHEMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1494224484/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexELXN_45whWh6w9K7PI1hsBguUP_YSKvarQq1mK8ZvE35kMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1494224484/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexcgrRNkQr2EoLd9r0qjlMY8vavbYwF7O_DhMLCpf_2cMMeta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexWIpDilZh5sFD9wa_4qRJfjHSBwTA_45YsNUXQXpa9pfpkMeta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexiWvao2SbfpswX7NuiTElh_w_RQy1eqh7ifP4Oa7cr0sMeta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmeu5o926kpDJFpaL3Uq4KOupjhwMPOMMswETWZIhUJScMeta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmNy9_UztvDATMtzJw75K9SBuVBrGi_DcKT2XzHKpv_r4Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1494224484/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completePtx8Vf7Gk4ec0CS5mQUK7DNncsYImuHGLc6nqnmTsaMMeta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerBDeWZQk7zldNRdCWsUb891giSybq9jPlsN0tuY9IyIAMeta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm5jqt6m29B_45_45XgR3ghHfgj3X4MzE0yfLsCi6HE_b7OzAMeta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codefGVebUPLicE3NBFNntx8cIMbWgc_E5xladuIbqcTg4UMeta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeduAgn6eIkUJPw2TaeDr2QBqNczHuMFnvdtgnC7Vdh_45wMeta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeV4pMUsYBlosw4oM5kjzf518hQnARixL_45ZGVTb6eepMUMeta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerc8eO76sGbotARjnLAPEzr_459AFyCoOrkg7LlYBP72ycsMeta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmC4A2Tcy_45_45p5_45DeVaDrBFF_iofrZwXVGHRE94QVzZUcoMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeBfShZYPGYqpLqpmQDlcCWeRaPHBXT5drXClJxdUnKn8Meta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexDS1tbXKBVsSkkbDvh_5ncKG4cL3sSzdocRH4tD6Hwr0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeIvugPrzKXfyM4FrSIzrrBIy6Yi16Rb8MXKsRHahwvuYMeta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampledJYbS3h3b2DFADqYZmEVYujwA7Mc3y9NceytxpCzjSIMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailWhUllfF4_45qHId4FDDbuO1_45OCZpx1kiMkx8YBOtzmz4sMeta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm8dQX1VLZdiCarP5bJl6wDLUeKzlkrxPVLUWZTZX4TVkMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentt_45kEGattoZ5GiD6ERfrFh8XUIr1qwdD3Qw2MtMuvX1QMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm6yvVeSWp0tzf38vsRxiHZiRCnQjfHPITREdkbnrT3Q4Meta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete412cyNG2kfQah_454fczNXg1cL0rhVeuEwoGE8OaBxN_45sMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeM1uXwGeAtZNB8IYS803ZN51OmCNFO2sPVLhfhttarh0Meta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordDvCH0_45zR78UbaCgxEdBkJdjJfrR2BtZpqLBmW1fHihsMeta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerURHUuMtmyvL3QXagc9KmHzuJ8GW_nANh1pOs0SSd36kMeta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code4Tb4G3debtEviWXeuUugrUxNrnvvuoVWRGs2pP_uQ5sMeta || {},
    component: () => import("/codebuild/output/src1494224484/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1494224484/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]